import { cn } from '@repo/lib/cn';

import { Checkbox } from '@/components/ui/checkbox';
import { Markdown } from '@/components/ui/markdown';
import { questionCorrect } from '@/lib/quiz';

import type { QuestionMultipleAnswerProps } from '.';

export function QuestionMultipleAnswer(questionMultipleProps: QuestionMultipleAnswerProps) {
  const { answer, checked, onCheckedChange, showMarked, correct, disabled, ...props } = questionMultipleProps;

  const { getStateClassNames, getIcon } = questionCorrect(correct);

  return (
    <div
      className={cn(
        'bg-surface-primary relative flex w-full cursor-pointer items-start gap-2 rounded-md border p-3 shadow-xs transition-colors duration-100 outline-none has-disabled:cursor-not-allowed md:p-4',
        getStateClassNames()
      )}
    >
      <Checkbox
        id={answer.id}
        value={answer.id}
        checked={checked}
        onCheckedChange={onCheckedChange}
        className={'after:absolute after:inset-0'}
        aria-describedby={`${answer.id}-description`}
        disabled={showMarked || disabled}
        {...props}
      />
      <div className="grid grow gap-2">
        <Markdown content={answer.content} imageClassName={'max-h-68 rounded-sm'} videoClassName={'max-h-68 rounded-sm'} />
      </div>
      {getIcon()}
    </div>
  );
}
